<template>
  <div class="bq-page bq-about" :class="{ 'bq-page-wireless': isMobile }">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="item in tabs" :key="item.title">
        <banner :cover="banner[activeIndex]" />
      </swiper-slide>
    </swiper>

    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <Intro slot="Intro" />
      <Incubator slot="Incubator" />
      <News slot="News" />
    </BqTab>
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import BqTab from '@/components/website_v3/Tab';

import { banner, aboutData } from './about.js';
import { locatTo } from '../../../utils/utils.js';
import Intro from './Intro';
import News from './News';
import Incubator from './Incubator';
// import setSpm from '@alife/set-spm';

export default {
  name: 'about',

  components: {
    Banner,
    BqTab,
    Intro,
    News,
    Incubator,
  },

  data() {
    return {
      swiperOptions: {
        // pagination: {
        //   el: '.swiper-pagination',
        // },
        // Some Swiper option/callback...
      },
      isMobile: false,
      banner,
      aboutData,
      visible: false,
      activeJob: {},
      activeIndex: parseInt(this.$route.query.id || '0'),
      tabs: [
        { title: '公司简介', slot: 'Intro', coverType: 'coverIntro' },
        { title: '扁鹊孵化器', slot: 'Incubator', coverType: 'coverIncu' },
        { title: '新闻动态', slot: 'News', coverType: 'coverNews' },
      ],
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  watch: {
    $route: {
      handler() {
        this.activeIndex = parseInt(this.$route.query.id);
        this.sendSpm();
        // console.log(this.activeIndex);
      },
      deep: true,
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  mounted() {
    this.sendSpm();
  },

  methods: {
    sendSpm() {
      const spma = 'a2o2ij';
      const spmbArr = ['14898881', '14898888', '14898905'];
      const index = parseInt(this.$route.query.id);
      const spmb = spmbArr[index];
      console.log(`${spma}.${spmb}`);
      // setSpm(`${spma}.${spmb}`);
    },
    handleClick(index) {
      this.activeIndex = index;
      this.swiper.slideTo(index);
    },
    // 应用于底部导航的页面跳转定位
    locatTo(locatName) {
      const posYArr = {
        intro: 150,
        culture: 150,
        jobs: 50,
        concat: 100,
      };

      setTimeout(() => {
        const target = document.getElementsByClassName(locatName);
        if (target.length) {
          locatTo(target[0].offsetTop - posYArr[locatName]);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
